import { createEvent, restore, sample } from 'effector'
import { fx, path } from 'src/libs'
import { languages } from '../../../../../libs/languages'
import { $params, toPath } from '../../../../../features/router'
import { SocialMediaItem } from '../list/types'
import { Offer } from '../../offers/list/types'
import { getOffers } from '../../offers/list/model'

export const setSocialMediaForm = createEvent<SocialMediaItem>()

export const socialMediaMounted = createEvent()

export const offersByLangMounted = createEvent<{ lang: string }>()

export const submitUpdateSocialMedia =
  createEvent<Omit<SocialMediaItem, 'id' | 'socialMediaFiles' | 'offer'>>()

export const $socialMedia = restore(setSocialMediaForm, {
  id: 0,
  lang: `${languages[0].value}`,
  title: '',
  offerId: 0,
  isVisible: false,
  offer: {
    title: '',
  },
  socialMediaFiles: [],
})

export const $offersByLang = restore<Offer[]>(
  getOffers.doneData.map((a) => a.body.items),
  [],
)

export const getSocialMediaGroup = fx<void, SocialMediaItem>({
  method: 'GET',
  url: '/partner/material/social_media/{id}',
})

export const updateSocialMediaGroup = fx<
  Omit<SocialMediaItem, 'id' | 'socialMediaFiles' | 'offer'>,
  void
>({
  method: 'PUT',
  url: '/partner/material/social_media/{id}',
})

sample({
  clock: socialMediaMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.socialMediaID
    }
    return {
      url: `/partner/material/social_media/${id}`,
    }
  },
  target: getSocialMediaGroup,
})

sample({
  clock: submitUpdateSocialMedia,
  source: $params,
  fn: (params, socialMediaGroup) => {
    let id
    if (params) {
      id = params.socialMediaID
    }

    return {
      url: `/partner/material/social_media/${id}`,
      body: { ...socialMediaGroup },
    }
  },
  target: updateSocialMediaGroup,
})

sample({
  clock: [getSocialMediaGroup.doneData],
  fn: (doneData) => doneData.body,
  target: [setSocialMediaForm, offersByLangMounted],
})

sample({
  clock: [updateSocialMediaGroup.doneData],
  target: toPath.prepend(path.ib.ad.socialMedia.entry),
})

sample({
  // @ts-ignore
  clock: offersByLangMounted,
  fn: ({ lang }) => {
    let query = {
      lang,
    }

    return {
      query,
    }
  },
  target: getOffers,
})
